import Layout from '@/layout/index.vue';
var systemRouter = {
  path: '/system',
  component: Layout,
  redirect: '/system/setting',
  name: 'system',
  meta: {
    title: '系统管理',
    roles: ['admin']
  },
  children: [{
    path: 'setting',
    name: 'setting',
    component: function component() {
      return import('@/views/system/setting/index.vue');
    },
    meta: {
      title: '系统设置'
    }
  }, {
    path: 'dev',
    name: 'dev',
    component: function component() {
      return import('@/views/system/index.vue');
    },
    meta: {
      title: '开发设置'
    },
    children: [{
      path: 'configCategory',
      name: 'configCategory',
      component: function component() {
        return import('@/views/system/dev/configCategory.vue');
      },
      meta: {
        title: '配置分类'
      }
    }, {
      path: 'combinedData',
      name: 'combinedData',
      component: function component() {
        return import('@/views/system/dev/combinedData.vue');
      },
      meta: {
        title: '组合数据'
      }
    }, {
      path: 'formConfig',
      name: 'formConfig',
      component: function component() {
        return import('@/views/system/dev/formConfig/index.vue');
      },
      meta: {
        title: '表单配置'
      }
    }]
  }, {
    path: 'pkg',
    name: 'pkg',
    component: function component() {
      return import('@/views/base/pkg/index.vue');
    },
    meta: {
      title: '渠道包管理'
    }
  }, {
    path: 'permission',
    name: 'permission',
    component: function component() {
      return import('@/views/system/permission/index.vue');
    },
    meta: {
      title: '权限管理',
      roles: ['admin']
    },
    children: [{
      path: 'admin',
      component: function component() {
        return import('@/views/system/permission/admin/index.vue');
      },
      name: 'admin',
      meta: {
        title: '管理员'
      }
    }, {
      path: 'menu',
      component: function component() {
        return import('@/views/system/permission/menu/index.vue');
      },
      name: 'menu',
      meta: {
        title: '菜单管理'
      }
    }, {
      path: 'role',
      component: function component() {
        return import('@/views/system/permission/role/index.vue');
      },
      name: 'role',
      meta: {
        title: '角色管理'
      }
    }]
  }, {
    path: 'picture',
    name: 'picture',
    component: function component() {
      return import('@/views/base/picture/index.vue');
    },
    meta: {
      title: '素材管理'
    }
  }, {
    path: 'sensitiveLog',
    name: 'sensitiveLog',
    component: function component() {
      return import('@/views/system/sensitiveList/index.vue');
    },
    meta: {
      title: '敏感操作日志'
    }
  }]
};
export default systemRouter;